import { render, staticRenderFns } from "./AuthorsTable.vue?vue&type=template&id=08115585&scoped=true&"
import script from "./AuthorsTable.vue?vue&type=script&lang=js&"
export * from "./AuthorsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsTable.vue?vue&type=style&index=0&id=08115585&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08115585",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VDataTable,VIcon,VRow})
